module.exports = __webpack_public_path__ + "img/rang6.1c46c11c.png";